import { ContractOrderOutputDto } from '@api/client';
import { useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'shared/utils/common.utils';
import ActiveOrderTotalInvoicesRecapModal from '../active-order-total-invoices-recap-modal';

interface Props {
  order: ContractOrderOutputDto;
  idOrdine: number | undefined;
}

const ActiveOrderDataTable: React.FC<Props> = ({ order, idOrdine }) => {
  const { t } = useTranslation();
  const [totalInvoicesRecapModalVisible, setTotalInvoicesRecapModalVisible] = useState(false);

  if (order) {
    return (
      <div className="table-responsive table-bordered mt-3">
        <Table className={'mt-0 mb-0'}>
          <thead className="bg-red">
            <tr>
              <th scope="col">
                <span>{'Order'}</span>
              </th>
              <th scope="col">
                <span>{'Tot. Amount'}</span>
              </th>
              <th scope="col">
                <span>{'A. Revenues'}</span>
              </th>
              <th scope="col">
                <span>{'Invoices issued'}</span>
              </th>
              <th scope="col">
                <span>{'Tot. Projects'}</span>
              </th>
              {/* <th scope="col">
                <span>{'FdE'}</span>
              </th> */}
              <th scope="col">
                <span>{'Remaining amount'}</span>
              </th>
              <th scope="col">
                <span>{'Link Doc'}</span>
              </th>
              <th scope="col">
                <span>{'Link Order'}</span>
              </th>
              <th scope="col">
                <span>{'Invoices'}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span className="d-inline-flex align-items-center">
                  <p className="my-auto">{`(${order.idExternalContract})${order.object}`}</p>
                </span>
              </td>
              <td className="text-end">
                <span className="d-inline-flex align-items-center">
                  <p className="my-auto">{formatCurrency(order.contractValue)}€</p>
                </span>
              </td>
              <td className="text-end">
                <span className="d-inline-flex align-items-center">
                  <p className="my-auto">{formatCurrency(order.ordARicavi)}€</p>
                </span>
              </td>
              <td className="text-end">
                <span className="d-inline-flex align-items-center">
                  <p className="my-auto">
                    {order.ordFattureEmesse ? `${formatCurrency(order.ordFattureEmesse)}€` : '-'}
                  </p>
                </span>
              </td>
              <td className="text-end">
                <span className="d-inline-flex align-items-center">
                  <p className="my-auto">{order.ordPrjTotAmount ? `${formatCurrency(order.ordPrjTotAmount)}€` : '-'}</p>
                </span>
              </td>
              {/* <td className="text-end">
                <span className="d-inline-flex align-items-center">
                  <p className="my-auto">{order.fde ? `${formatCurrency(Number(order.fde))}€` : '-'}</p>
                </span>
              </td> */}
              <td className="text-end">
                <span className="d-inline-flex align-items-center">
                  <p className="my-auto">{formatCurrency(order.remainingBalance)}€</p>
                </span>
              </td>
              <td>
                {order.linkDocumentation ? (
                  <a href={order.linkDocumentation} target="_blank" rel="noreferrer">
                    <i className="icon-noun-link text-blue-links fs-6" />
                  </a>
                ) : (
                  '-'
                )}
              </td>
              <td>
                {order.linkOrdine ? (
                  <a href={order.linkOrdine} target="_blank" rel="noreferrer">
                    <i className="icon-noun-link text-blue-links fs-6" />
                  </a>
                ) : (
                  '-'
                )}
              </td>
              <td className="text-center">
                <Button
                  className="btn text-blue-links border-none p-0"
                  type="button"
                  variant="icon"
                  onClick={() => setTotalInvoicesRecapModalVisible(true)}
                >
                  <i className="icon-eye-shows text-blue-links" />
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
        <ActiveOrderTotalInvoicesRecapModal
          isOpen={totalInvoicesRecapModalVisible}
          onClose={() => setTotalInvoicesRecapModalVisible(false)}
          idOrdine={idOrdine}
        />
      </div>
    );
  } else {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '4rem' }}>
        {t('No order details')}
      </div>
    );
  }
};

export default ActiveOrderDataTable;
